import { Separator, SocialSharingGroup } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { CopyLinkVisibleUrlButton, SocialIconWithSuccessState } from 'src/app/shared/components/share';

import { useShareActions } from './hooks/useShareActions';

export const ShareActions = () => {
	const { translate } = useI18n();
	const { data } = useShareActions();

	const { first, rest, mobileShareVisual, desktopShareVisualVariant1 } = data;

	if (rest.length === 0 && !desktopShareVisualVariant1 && !mobileShareVisual) return null;

	return (
		<>
			{first && <CopyLinkVisibleUrlButton buttonConfig={first} data-qa="psf-share-copy-button" />}

			{!desktopShareVisualVariant1 && <Separator orientation="horizontal" className="m-0" />}

			{mobileShareVisual && (
				<img
					src={mobileShareVisual}
					alt={translate('corgi.psf.share.share_visual_preview_alt')}
					className="mx-auto my-2 block max-w-61 rounded-lg"
					data-qa="psf-share-mobile-asset"
				/>
			)}

			{desktopShareVisualVariant1 && (
				<img
					src={desktopShareVisualVariant1}
					alt={translate('corgi.psf.share.share_visual_preview_alt')}
					className="mx-auto block w-72 rounded-lg"
					data-qa="psf-share-desktop-asset-variant1"
				/>
			)}

			<SocialSharingGroup layout="grid" className="items-start justify-items-center gap-y-8 md:grid-cols-5">
				{rest.filter(Boolean).map((actionItem) => (
					<SocialIconWithSuccessState
						key={actionItem.channel}
						data-qa={`psf-share-${actionItem.channel}-button`}
						buttonConfig={actionItem}
						className="text-center"
					/>
				))}
			</SocialSharingGroup>
		</>
	);
};
